import { useEffect } from 'react';
import type Report from './index';

interface UseMicroAppReportPVProps {
  instance: Report;
}

/**
 * 在 qiankun 子应用中使用的 Hook，用于自动监听路由变化并上报 PV
 */
export const useMicroAppReportPV = ({ instance }: UseMicroAppReportPVProps): void => {
  const { pathname, hash } = window.location;

  useEffect(() => {
    // 空值检查
    if (!instance || !instance.uin) {
      return;
    }

    // 错误处理
    try {
      instance.reportAction('page-view');
    } catch (error) {
      console.warn('Data-report-hub useMicroAppReportPV error:', error);
    }
  }, [pathname, hash, instance]);
};
